/* eslint-disable import/prefer-default-export */
import API from 'utils/api';
import { onError, onSuccess } from 'utils/handlers';

export const baseURI = '/recaudacion/configuraciones-de-asignaciones-de-placas/';

/**
 * GET Many configuraciones de asignaciones
 * @returns {Object[]}
 * @param {Array} ids
 * @returns {Promis<object[]>} response
 */
export const getManyConfiguracionesAsignaciones = async (ids = []) => {
  try {
    if (!ids.length) return [];
    const promises = ids.map((id) => API.get(`${baseURI}${id}/`));
    const responses = await Promise.all(promises);
    return responses.map((e) => e.data);
  } catch (err) {
    onError(err);
    return [];
  }
};

/** GET Configuraciones de asignaciones de placas
  * @param {Object} params
  */
export const postGetConfiguracionDeAsignacionDePlacas = async (params = null) => {
  try {
    const response = await API.post('recaudacion/obtener-siguiente-placa/', params);
    return response.data;
  } catch (err) {
    onError(err);
    return [];
  }
};

/** GET Configuraciones de asignaciones de placas
  * @param {Object} params
  */
export const getConfiguracionesDeAsignacionDePlacas = async (params = null) => {
  try {
    const response = await API.get(baseURI, { params });
    return response.data;
  } catch (err) {
    onError(err);
    return [];
  }
};

/** GET Configuracion de asignaciones de placas
 *  @param {number} id
 */
export const getConfiguracionDeAsignacionDePlacas = async (id) => {
  try {
    const response = await API.get(`${baseURI}${id}`);
    return response.data;
  } catch (err) {
    onError(err);
    return null;
  }
};

/** POST Configuracion de asignaciones de placas
 * @param {Object} values
 */
export const postConfiguracionDeAsignacionDePlacas = async (values) => {
  try {
    const response = await API.post(baseURI, values);
    onSuccess(response, 'Registrado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return null;
  }
};

/** PATCH Configuracion de asignaciones de placas
 * @param {Object} values
 * @param {Number} id
 * @returns {Array} response
 */
export const patchConfiguracionDeAsignacionDePlacas = async (id, values) => {
  try {
    const response = await API.patch(`${baseURI}${id}/`, values);
    onSuccess(response, 'Actualizado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return null;
  }
};

/** DELETE Configuracion de asignaciones de placas
 * @param {Number} id
 * */
export const deleteConfiguracionDeAsignacionDePlacas = async (id) => {
  try {
    const response = await API.delete(`${baseURI}${id}/`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};
